export enum Routes {
  root = '/',
  aboutUs = '/about-us',
  contactUs = '/contact-us',

  videos = '/vidz',
  techniques = '/techniques',
  creativityTool = '/creativity-tool',

  product = '/product',
  collection = '/collection',

  cart = '/cart',
  checkout = '/checkout',
  order = '/order',

  designers = '/designers',

  signIn = '/sign-in',
  signUp = '/sign-up',

  // NOTE: Middleware handles side effects for this routes:
  // - Unauthenticated users are redirected to the sign-in page.
  // - Authenticated users are redirected to the account dashboard.
  account = '/account',
  accountStatus = `${account}/status`,

  shop = '/shop',

  admin = '/admin',
}

export enum APIRoutes {
  api = '/api',
  users = `${api}/users`,
  products = `${api}/products`,
  videos = `${api}/videos`,
  post = `${api}/post`,

  stripeAccount = `${api}/stripe/account`,
  stripeAccountSession = `${api}/stripe/account-session`,
  stripePaymentIntent = `${api}/stripe/payment-intent`,

  cart = `${api}/cart`,
  cartProduct = `${api}/cart/product`,

  order = `${api}/order`,
  subOrder = `${api}/sub-order`,

  clerk = `${api}/clerk`,
}
